import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/health-check')({
  component: Index,
})

function Index() {
  return null
}
